import { renderBanner, renderSection } from '@/contentful';
import * as React from 'react';
import { PageSectionFieldsFragment, PageSectionsBySystemIdQuery } from 'types/generated';
import RoamingInfo from './RoamingInfo';
import { CountryData } from './types';
import Section from '../Section';

type Props = {
  sections: Array<PageSectionsBySystemIdQuery>;
  orderedIds: Array<string>;
  reikiCountries: Array<CountryData>;
};

const Roaming = ({ sections, orderedIds, reikiCountries }: Props) => {
  const pageSections = sections
    .flatMap((x) => x.pageSectionCollection?.items as PageSectionFieldsFragment[])
    .sort((a, b) => orderedIds.indexOf(a.sys.id) - orderedIds.indexOf(b.sys.id));

  const topBannerSection = pageSections[0]?.children?.__typename === 'Banner' ? pageSections[0] : null;
  const firstInfoSetSection = pageSections.find((section) => section.children?.__typename === 'InfoSet');
  const firstTabCollectionSection = pageSections.find((section) => section.children?.__typename === 'TabGroup');

  const filteredSections = pageSections.filter(
    (section) =>
      section.id !== topBannerSection?.id &&
      section.id !== firstInfoSetSection?.id &&
      section.id !== firstTabCollectionSection?.id
  );

  const topBanner = topBannerSection?.children?.__typename === 'Banner' ? topBannerSection.children : null;
  const firstInfoSet = firstInfoSetSection?.children?.__typename === 'InfoSet' ? firstInfoSetSection.children : null;
  const firstTabCollection =
    firstTabCollectionSection?.children?.__typename === 'TabGroup' ? firstTabCollectionSection.children : null;

  return (
    <>
      <Section
        childrenTypeName={undefined}
        sectionId={undefined}
        marginTop={128}
        marginBottom={32}
        gridType="full"
        theme={'white-15'}
      >
        {topBanner && renderBanner(topBanner)}
      </Section>
      <RoamingInfo
        infoSetId={firstInfoSet?.sys?.id || ''}
        firstTabCollection={firstTabCollection}
        reikiCountries={reikiCountries}
      />
      {filteredSections.map((s, index) => renderSection(s, index === 0))}
    </>
  );
};

export default Roaming;
